export const ACCEPTED_FORMATS = '.pdf,.tiff,.tif,.jpeg,.jpg,.png'

export const BUTTON_TEXT = {
  default: 'Upload Document',
  loading: 'Processing...',
} as const
